import TYPES from '@/types';
import i18n from '@/vue-app/plugins/i18n';
import { currencyFormat } from '@/vue-app/utils/currency';

// Application
import CustomerOverviewService from '@/modules/home-dashboard/customer-overview/application/services/customer-overview-service';

// Domain
import Inject from '@/modules/shared/domain/di/inject';
import { StateManager as AllianzAccountReportStateManager } from '@/modules/my-investment/allianz/allianz-account-report/domain/state/state-manager';
import { StateManager as KuspitPositionStateManager } from '@/modules/my-investment/kuspit/customer-kuspit-position/domain/state/state-manager';
import CustomerOverviewState from '@/modules/home-dashboard/customer-overview/domain/state/customer-overview-state';

export default class MyPersonalBalanceViewModelV2 {
  @Inject(TYPES.CUSTOMER_OVERVIEW_SERVICE)
  private readonly customer_overview_service!: CustomerOverviewService;

  @Inject(TYPES.ALLIANZ_ACCOUNT_REPORT_STATE_MANAGER)
  private readonly allianz_account_report_state_manager!: AllianzAccountReportStateManager;

  @Inject(TYPES.CUSTOMER_KUSPIT_POSITION_STATE_MANAGER)
  private readonly kuspit_position_state_manager!: KuspitPositionStateManager;

  readonly i18n_namespace = 'components.my-investment-dashboard.my-personal-balance';

  customer_overview: CustomerOverviewState = this.customer_overview_service.get_customer_overview();

  get is_loading() {
    return this.customer_overview.is_loading
      || this.allianz_account_report_state_manager.state.is_loading
      || this.kuspit_position_state_manager.state.is_loading;
  }

  get has_allianz_account() {
    return this.customer_overview.item.wealth_investment_product_overview.contracted;
  }

  get has_kuspit_account() {
    return this.customer_overview.item.pocket_investment_product_overview.contracted;
  }

  get customer_has_investment_product() {
    return this.customer_overview.item.has_any_product_contracted;
  }

  get balance() {
    let kuspit_balance = 0;
    if (this.kuspit_position_state_manager.state.position.position) {
      kuspit_balance = parseFloat(this.kuspit_position_state_manager.state.position.position);
    }
    const allianz_balance = this.allianz_account_report_state_manager.state.items.reduce(
      (total, current) => total + current.final_balance_mxn!, 0,
    );
    return `${currencyFormat(allianz_balance + kuspit_balance)} MXN`;
  }

  translate = (value: string) => (
    i18n.t(`${this.i18n_namespace}.${value}`) as string
  )
}
